import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
  requestRelatedPhases,
  createRelatedPhase,
  removeRelatedPhase,
} from 'actionCreators/related_phases';
import { createMergedPhases } from 'actionCreators/merged_phases';
import { fetchPhaseDocuments } from 'actionCreators';
import { can } from '../../../../../../../services';
import { getRole, getPosition } from '../../../../../../../reducers';
import Card from 'components/Card';
import CardTitle from 'components/CardTitle';
import PhaseSearch from './components/phaseSearch';
import PhaseType from 'types/phase';
import PhaseCard from '../../../phaseList/components/phaseCard';
import Loading from 'components/Loading';
import MessageBox from 'components/MessageBox';
import { visibleFor } from 'components/Auth';
import ConfirmDialog from 'components/ConfirmDialog';

import styles from './styles.scss';

const RelatedPhaseSearch = visibleFor('update', 'related_phase', ({ phase, onLinkClick, relatedPhaseIds }) =>
  <div>
    <hr className={styles.dividerLine} />
    <PhaseSearch
      phase={phase}
      onLinkClick={onLinkClick}
      relatedPhaseIds={relatedPhaseIds}
    />
  </div>,
);

class RelatedPhases extends Component {
  constructor(props) {
    super(props);
    this.state = { showMergeConfirm: false };
    this.handleMergeConfirm = this.handleMergeConfirm.bind(this);
    this.onMergePhaseClick = this.onMergePhaseClick.bind(this);
  }

  componentWillMount = () => this.props.requestRelatedPhases(this.props.phase.id);

  onLinkClick = relatedPhaseId => this.props.createRelatedPhase(
    this.props.phase.id, relatedPhaseId,
  ).then(() => this.fetchDocsIfCv());

  onUnlinkClick = relatedPhaseId => this.props.removeRelatedPhase(
    this.props.phase.id, relatedPhaseId,
  ).then(() => this.fetchDocsIfCv());

  onMergePhaseClick = relatedPhaseId => this.props.createMergedPhases(
    this.props.phase.id, relatedPhaseId,
  ).then(() => this.fetchDocsIfCv())
   .then(() => this.handleMergeConfirm(false))
   .then(() => window.location.reload())

  handleMergeConfirm = (show = true) => this.setState({ showMergeConfirm: show });

  fetchDocsIfCv = () => (this.props.cv ?
    this.props.fetchPhaseDocuments(this.props.phase.id) :
    null)

  renderRelatedPhases = (relatedPhaseCards, loading) => {
    if (loading) return (<Loading />);
    else if (relatedPhaseCards.length === 0) {
      return (<div className={styles.emptyRelatedPhasesContainer}>
        No phase has been associated.
      </div>);
    }
    return relatedPhaseCards;
  }

  render() {
    const { phase, loading, relatedPhases, errors, role, position } = this.props;
    const relatedPhaseIds = [];
    const relatedPhaseCards = relatedPhases.map((relatedPhase) => {
      relatedPhaseIds.push(relatedPhase.id);
      const actionButton = can(role, 'relate', 'phase')
        ? { text: 'Unlink Phase', onClick: () => this.onUnlinkClick(relatedPhase.id) }
        : null;
      const actionButton2 = can(role, 'relate', 'phase')
        ? { text: 'Merge Phase', onClick: () => this.handleMergeConfirm() }
        : null;
      return (<Fragment key={`relatedPhase-${relatedPhase.id}`}>
        <PhaseCard
          role={role}
          position={position}
          phase={relatedPhase}
          sourcePhase={phase}
          store={relatedPhase.store}
          surfaceType={relatedPhase.surface_type}
          actionButton={actionButton}
          actionButton2={actionButton2}
        />
        {this.state.showMergeConfirm && <ConfirmDialog
          theActions={['OK']}
          title="Confirm Merge Phase"
          confirmation="Once the phases have been merged, it cannot be undone. Is that okay?"
          dismiss={() => this.handleMergeConfirm(false)}
          proceed={() => this.onMergePhaseClick(relatedPhase.id)}
        />}
      </Fragment>);
    });
    return (<div>
      <Card>
        <CardTitle
          title="Associated Phases"
          subtitle="Please select an assessment to link. This ensures that Contract Verification has access to the necessary documentation."
        />
        <div className={styles.relatedPhasesSectionContainer}>
          {errors.length !== 0 && <MessageBox error message={errors.join(', ')} />}
          {this.renderRelatedPhases(relatedPhaseCards, loading)}
        </div>
        <RelatedPhaseSearch
          phase={phase}
          onLinkClick={this.onLinkClick}
          relatedPhaseIds={relatedPhaseIds}
        />
      </Card>
    </div>);
  }
}

RelatedPhases.defaultProps = { cv: false };

RelatedPhases.propTypes = {
  requestRelatedPhases: PropTypes.func.isRequired,
  createRelatedPhase: PropTypes.func.isRequired,
  removeRelatedPhase: PropTypes.func.isRequired,
  fetchPhaseDocuments: PropTypes.func.isRequired,
  createMergedPhases: PropTypes.func.isRequired,
  phase: PhaseType.isRequired,
  relatedPhases: PropTypes.arrayOf(PhaseType),
  loading: PropTypes.bool,
  errors: PropTypes.array,
  role: PropTypes.string,
  position: PropTypes.string,
  cv: PropTypes.bool,
};

export default connect(state => ({
  phase: state.phase.details,
  relatedPhases: state.phase.related.data,
  errors: state.phase.related.errors,
  loading: state.phase.related.loading,
  role: getRole(state),
  position: getPosition(state),
}), {
  requestRelatedPhases,
  createRelatedPhase,
  removeRelatedPhase,
  fetchPhaseDocuments,
  createMergedPhases,
})(RelatedPhases);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/relatedPhases/index.jsx